// POSTS

// Return latest posts
export const latestPosts = state => state.latest_posts;

// Return all posts
export const posts = state => state.all_posts;

// Get one post
export const post = state => state.post;

// Get categories
export const categories = state => state.categories;

// FEATURES

// Return all features
export const features = state => state.features;

// FIGHTERS

// Return all fighters
export const fighters = state => state.fighters;

// Return all active fighters
export const activeFighters = state => {
  return state.fighters.filter(f => f.coming_soon === false);
};

// WALLPAPERS

// Return all wallpapers
export const wallpapers = state => state.wallpapers;

// SCREENSHOTS

// Return all screenshots
export const screenshots = state => state.screenshots;

// VIDEOS

// Return all videos
export const videos = state => state.videos;

// DOWNLOADS

// Return all downloads
export const downloads = state => state.downloads;

// PAGES

// Homepage
export const homepage = state => state.homepage;

// DMCA Policy
export const dmcaPolicy = state => state.dmcapolicy;

// USER

// User
export const user = state => state.user;

// MEDIA

// Get mediaCategories
export const mediaCategories = state => state.mediaCategories;

// Cookie Policy
export const cookiePolicy = state => state.cookiePolicy;



// WEBPACK FOOTER //
// ./src/store/getters.js